var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_592",
    "data-name": "Grupo 592",
    transform: "translate(-240 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_173",
    "data-name": "Ret\\xE2ngulo 173",
    transform: "translate(240 135)",
    fill: "#dcdcdc",
    stroke: "#dcdcdc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M10.419,5.914a4.846,4.846,0,0,1,.011,6.846l-.011.012L8.276,14.915A4.849,4.849,0,0,1,1.418,8.058L2.6,6.874a.51.51,0,0,1,.871.338,5.878,5.878,0,0,0,.309,1.682.513.513,0,0,1-.121.53l-.417.417a2.3,2.3,0,1,0,3.227,3.269l2.144-2.143a2.3,2.3,0,0,0,0-3.249,2.39,2.39,0,0,0-.33-.273.512.512,0,0,1-.222-.4,1.271,1.271,0,0,1,.373-.951l.672-.672a.512.512,0,0,1,.657-.055,4.864,4.864,0,0,1,.655.549Zm4.5-4.5a4.854,4.854,0,0,0-6.858,0L5.914,3.562,5.9,3.574a4.85,4.85,0,0,0,.666,7.394.513.513,0,0,0,.657-.055l.672-.672A1.271,1.271,0,0,0,8.27,9.29a.512.512,0,0,0-.222-.4,2.39,2.39,0,0,1-.33-.273,2.3,2.3,0,0,1,0-3.249L9.862,3.223A2.3,2.3,0,1,1,13.09,6.492l-.417.417a.513.513,0,0,0-.121.53,5.878,5.878,0,0,1,.309,1.682.51.51,0,0,0,.871.338l1.184-1.184a4.854,4.854,0,0,0,0-6.857Z",
    transform: "translate(252 147)",
    fill: "#fd1c50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.26e67ab9fcf958cefade9626c7f43bee.svg";
export { ForwardRef as ReactComponent };